import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export type Chatroom_File_Field = {
  ADD_USER_ID: Scalars['String']['output'];
  ADD_USER_NM: Scalars['String']['output'];
  CHATROOM_ID: Scalars['String']['output'];
  MESSAGE_ID: Scalars['Int']['output'];
  NAME: Scalars['String']['output'];
  PATH: Scalars['String']['output'];
};

export type Chatroom_File_List = {
  items?: Maybe<Array<Maybe<Chatroom_File_Field>>>;
};

export type Chatroom_List_Field = {
  CHATROOM_ID: Scalars['String']['output'];
  DELETE_FLG: Scalars['String']['output'];
  KEY: Scalars['String']['output'];
  SUB_KEY: Scalars['String']['output'];
  KIND: Scalars['String']['output'];
  NAME: Scalars['String']['output'];
};

export type Chatroom_List_List = {
  items?: Maybe<Array<Maybe<Chatroom_List_Field>>>;
};

export type Chatroom_Member_Field = {
  CHATROOM_ID: Scalars['String']['output'];
  KIND: Scalars['String']['output'];
  READ_MESSAGE_ID: Scalars['Int']['output'];
  USER_ID: Scalars['String']['output'];
};

export type Chatroom_Member_List = {
  items?: Maybe<Array<Maybe<Chatroom_Member_Field>>>;
};

export type Chatroom_Message_Field = {
  ADD_DT: Scalars['Int']['output'];
  ADD_USER_ID: Scalars['String']['output'];
  ADD_USER_NM: Scalars['String']['output'];
  CHATROOM_ID: Scalars['String']['output'];
  EDIT_FLG: Scalars['String']['output'];
  FILE_FLG: Scalars['String']['output'];
  MESSAGE_BODY: Scalars['String']['output'];
  MESSAGE_ID: Scalars['Int']['output'];
};

export type Chatroom_Message_List = {
  items?: Maybe<Array<Maybe<Chatroom_Message_Field>>>;
};

export type Chatroom_Notice_Field = {
  CHATROOM_ID: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  MESSAGE_ID: Scalars['Int']['output'];
  NOTICE_FLG: Scalars['String']['output'];
  SEND_MAIL_FLG: Scalars['String']['output'];
  USER_ID: Scalars['String']['output'];
};

export type Chatroom_Notice_List = {
  items?: Maybe<Array<Maybe<Chatroom_Notice_Field>>>;
};

export type Mutation = {
  DeleteChatroom?: Maybe<Chatroom_List_Field>;
  DeleteChatroomMember?: Maybe<Chatroom_Member_Field>;
  DeleteFile?: Maybe<Chatroom_File_List>;
  DeleteMessage?: Maybe<Chatroom_Message_Field>;
  RegisterChatroom?: Maybe<Chatroom_List_Field>;
  RegisterChatroomMember?: Maybe<Chatroom_Member_Field>;
  RegisterFile?: Maybe<Chatroom_File_List>;
  RegisterFileMessage?: Maybe<Chatroom_Message_Field>;
  RegisterMessage?: Maybe<Chatroom_Message_Field>;
  RegisterNotice?: Maybe<Chatroom_Notice_Field>;
  UpdateChatroom?: Maybe<Chatroom_List_Field>;
  UpdateChatroomReadStatus?: Maybe<Chatroom_Member_Field>;
  UpdateMessage?: Maybe<Chatroom_Message_Field>;
  UpdateNotice?: Maybe<Chatroom_Notice_Field>;
};

export type MutationDeleteChatroomArgs = {
  CHATROOM_ID: Scalars['String']['input'];
};

export type MutationDeleteChatroomMemberArgs = {
  CHATROOM_ID: Scalars['String']['input'];
  USER_ID: Scalars['String']['input'];
};

export type MutationDeleteFileArgs = {
  CHATROOM_ID: Scalars['String']['input'];
  MESSAGE_ID: Scalars['Int']['input'];
};

export type MutationDeleteMessageArgs = {
  CHATROOM_ID: Scalars['String']['input'];
  MESSAGE_ID: Scalars['Int']['input'];
};

export type MutationRegisterChatroomArgs = {
  KEY: Scalars['String']['input'];
  SUB_KEY: Scalars['String']['input'];
  KIND: Scalars['String']['input'];
  NAME: Scalars['String']['input'];
};

export type MutationRegisterChatroomMemberArgs = {
  CHATROOM_ID: Scalars['String']['input'];
  KIND: Scalars['String']['input'];
  READ_MESSAGE_ID: Scalars['Int']['input'];
  USER_ID: Scalars['String']['input'];
};

export type MutationRegisterFileArgs = {
  ADD_USER_ID: Scalars['String']['input'];
  ADD_USER_NM: Scalars['String']['input'];
  CHATROOM_ID: Scalars['String']['input'];
  MESSAGE_ID: Scalars['Int']['input'];
  NAME: Scalars['String']['input'];
  PATH: Scalars['String']['input'];
};

export type MutationRegisterFileMessageArgs = {
  ADD_USER_ID: Scalars['String']['input'];
  ADD_USER_NM: Scalars['String']['input'];
  CHATROOM_ID: Scalars['String']['input'];
  FILE_NAME: Scalars['String']['input'];
};

export type MutationRegisterMessageArgs = {
  ADD_USER_ID: Scalars['String']['input'];
  ADD_USER_NM: Scalars['String']['input'];
  CHATROOM_ID: Scalars['String']['input'];
  MESSAGE_BODY: Scalars['String']['input'];
};

export type MutationRegisterNoticeArgs = {
  CHATROOM_ID: Scalars['String']['input'];
  MESSAGE_ID: Scalars['Int']['input'];
  USER_ID: Scalars['String']['input'];
};

export type MutationUpdateChatroomArgs = {
  CHATROOM_ID: Scalars['String']['input'];
  NAME: Scalars['String']['input'];
};

export type MutationUpdateChatroomReadStatusArgs = {
  CHATROOM_ID: Scalars['String']['input'];
  READ_MESSAGE_ID: Scalars['Int']['input'];
  USER_ID: Scalars['String']['input'];
};

export type MutationUpdateMessageArgs = {
  CHATROOM_ID: Scalars['String']['input'];
  MESSAGE_BODY: Scalars['String']['input'];
  MESSAGE_ID: Scalars['Int']['input'];
};

export type MutationUpdateNoticeArgs = {
  ID: Scalars['String']['input'];
};

export type Query = {
  GetAllMessage?: Maybe<Chatroom_Message_List>;
  GetChatroomByKind?: Maybe<Chatroom_List_List>;
  GetChatroomDetail?: Maybe<Chatroom_List_Field>;
  GetChatroomFileList?: Maybe<Chatroom_File_List>;
  GetChatroomList?: Maybe<Chatroom_Member_List>;
  GetChatroomMember?: Maybe<Chatroom_Member_List>;
  GetChatroomReadStatus?: Maybe<Chatroom_Member_Field>;
  GetMessage?: Maybe<Chatroom_Message_List>;
  GetNotice?: Maybe<Chatroom_Notice_List>;
  SearchMessage?: Maybe<Chatroom_Message_List>;
};

export type QueryGetAllMessageArgs = {
  CHATROOM_ID: Scalars['String']['input'];
};

export type QueryGetChatroomByKindArgs = {
  KEY: Scalars['String']['input'];
  SUB_KEY: Scalars['String']['input'];
};

export type QueryGetChatroomDetailArgs = {
  CHATROOM_ID: Scalars['String']['input'];
};

export type QueryGetChatroomFileListArgs = {
  CHATROOM_ID: Scalars['String']['input'];
};

export type QueryGetChatroomListArgs = {
  USER_ID: Scalars['String']['input'];
};

export type QueryGetChatroomMemberArgs = {
  CHATROOM_ID: Scalars['String']['input'];
};

export type QueryGetChatroomReadStatusArgs = {
  CHATROOM_ID: Scalars['String']['input'];
  USER_ID: Scalars['String']['input'];
};

export type QueryGetMessageArgs = {
  CHATROOM_ID: Scalars['String']['input'];
  MESSAGE_ID: Scalars['Int']['input'];
};

export type QueryGetNoticeArgs = {
  USER_ID: Scalars['String']['input'];
};

export type QuerySearchMessageArgs = {
  CHATROOM_ID: Scalars['String']['input'];
  MESSAGE_BODY: Scalars['String']['input'];
};

export type DeleteFileMutationVariables = Exact<{
  CHATROOM_ID: Scalars['String']['input'];
  MESSAGE_ID: Scalars['Int']['input'];
}>;

export type DeleteFileMutation = {
  DeleteFile?: {
    items?: Array<{
      ADD_USER_ID: string;
      ADD_USER_NM: string;
      CHATROOM_ID: string;
      MESSAGE_ID: number;
      NAME: string;
      PATH: string;
    } | null> | null;
  } | null;
};

export type GetChatroomFileListQueryVariables = Exact<{
  CHATROOM_ID: Scalars['String']['input'];
}>;

export type GetChatroomFileListQuery = {
  GetChatroomFileList?: {
    items?: Array<{
      ADD_USER_ID: string;
      ADD_USER_NM: string;
      CHATROOM_ID: string;
      MESSAGE_ID: number;
      PATH: string;
      NAME: string;
    } | null> | null;
  } | null;
};

export type RegisterFileMutationVariables = Exact<{
  ADD_USER_ID: Scalars['String']['input'];
  ADD_USER_NM: Scalars['String']['input'];
  CHATROOM_ID: Scalars['String']['input'];
  MESSAGE_ID: Scalars['Int']['input'];
  NAME: Scalars['String']['input'];
  PATH: Scalars['String']['input'];
}>;

export type RegisterFileMutation = {
  RegisterFile?: {
    items?: Array<{
      ADD_USER_ID: string;
      ADD_USER_NM: string;
      CHATROOM_ID: string;
      MESSAGE_ID: number;
      NAME: string;
      PATH: string;
    } | null> | null;
  } | null;
};

export type DeleteChatroomMutationVariables = Exact<{
  CHATROOM_ID: Scalars['String']['input'];
}>;

export type DeleteChatroomMutation = {
  DeleteChatroom?: { CHATROOM_ID: string; KEY: string; KIND: string; NAME: string; DELETE_FLG: string } | null;
};

export type GetChatroomByKindQueryVariables = Exact<{
  KEY: Scalars['String']['input'];
  SUB_KEY: Scalars['String']['input'];
}>;

export type GetChatroomByKindQuery = {
  GetChatroomByKind?: {
    items?: Array<{
      CHATROOM_ID: string;
      KEY: string;
      SUB_KEY?: string;
      KIND: string;
      NAME: string;
      DELETE_FLG: string;
    } | null> | null;
  } | null;
};

export type GetChatroomDetailQueryVariables = Exact<{
  CHATROOM_ID: Scalars['String']['input'];
}>;

export type GetChatroomDetailQuery = {
  GetChatroomDetail?: { CHATROOM_ID: string; KEY: string; KIND: string; NAME: string; DELETE_FLG: string } | null;
};

export type RegisterChatroomMutationVariables = Exact<{
  KEY: Scalars['String']['input'];
  SUB_KEY: Scalars['String']['input'];
  KIND: Scalars['String']['input'];
  NAME: Scalars['String']['input'];
}>;

export type RegisterChatroomMutation = {
  RegisterChatroom?: {
    CHATROOM_ID: string;
    KEY: string;
    SUB_KEY?: string;
    KIND: string;
    NAME: string;
    DELETE_FLG: string;
  } | null;
};

export type UpdateChatroomMutationVariables = Exact<{
  CHATROOM_ID: Scalars['String']['input'];
  NAME: Scalars['String']['input'];
}>;

export type UpdateChatroomMutation = {
  UpdateChatroom?: { CHATROOM_ID: string; KEY: string; KIND: string; NAME: string; DELETE_FLG: string } | null;
};

export type DeleteChatroomMemberMutationVariables = Exact<{
  CHATROOM_ID: Scalars['String']['input'];
  USER_ID: Scalars['String']['input'];
}>;

export type DeleteChatroomMemberMutation = {
  DeleteChatroomMember?: { CHATROOM_ID: string; KIND: string; READ_MESSAGE_ID: number; USER_ID: string } | null;
};

export type GetChatroomListQueryVariables = Exact<{
  USER_ID: Scalars['String']['input'];
}>;

export type GetChatroomListQuery = {
  GetChatroomList?: {
    items?: Array<{ USER_ID: string; CHATROOM_ID: string; KIND: string; READ_MESSAGE_ID: number } | null> | null;
  } | null;
};

export type GetChatroomMemberQueryVariables = Exact<{
  CHATROOM_ID: Scalars['String']['input'];
}>;

export type GetChatroomMemberQuery = {
  GetChatroomMember?: {
    items?: Array<{ USER_ID: string; CHATROOM_ID: string; KIND: string; READ_MESSAGE_ID: number } | null> | null;
  } | null;
};

export type GetChatroomReadStatusQueryVariables = Exact<{
  CHATROOM_ID: Scalars['String']['input'];
  USER_ID: Scalars['String']['input'];
}>;

export type GetChatroomReadStatusQuery = {
  GetChatroomReadStatus?: { CHATROOM_ID: string; KIND: string; READ_MESSAGE_ID: number; USER_ID: string } | null;
};

export type RegisterChatroomMemberMutationVariables = Exact<{
  CHATROOM_ID: Scalars['String']['input'];
  KIND: Scalars['String']['input'];
  READ_MESSAGE_ID: Scalars['Int']['input'];
  USER_ID: Scalars['String']['input'];
}>;

export type RegisterChatroomMemberMutation = {
  RegisterChatroomMember?: { CHATROOM_ID: string; KIND: string; READ_MESSAGE_ID: number; USER_ID: string } | null;
};

export type UpdateChatroomReadStatusMutationVariables = Exact<{
  CHATROOM_ID: Scalars['String']['input'];
  READ_MESSAGE_ID: Scalars['Int']['input'];
  USER_ID: Scalars['String']['input'];
}>;

export type UpdateChatroomReadStatusMutation = {
  UpdateChatroomReadStatus?: { CHATROOM_ID: string; KIND: string; READ_MESSAGE_ID: number; USER_ID: string } | null;
};

export type DeleteMessageMutationVariables = Exact<{
  CHATROOM_ID: Scalars['String']['input'];
  MESSAGE_ID: Scalars['Int']['input'];
}>;

export type DeleteMessageMutation = {
  DeleteMessage?: {
    ADD_USER_ID: string;
    ADD_USER_NM: string;
    CHATROOM_ID: string;
    MESSAGE_BODY: string;
    MESSAGE_ID: number;
    ADD_DT: number;
    EDIT_FLG: string;
    FILE_FLG: string;
  } | null;
};

export type GetAllMessageQueryVariables = Exact<{
  CHATROOM_ID: Scalars['String']['input'];
}>;

export type GetAllMessageQuery = {
  GetAllMessage?: {
    items?: Array<{
      ADD_USER_ID: string;
      ADD_USER_NM: string;
      CHATROOM_ID: string;
      MESSAGE_BODY: string;
      MESSAGE_ID: number;
      ADD_DT: number;
      EDIT_FLG: string;
      FILE_FLG: string;
    } | null> | null;
  } | null;
};

export type GetMessageQueryVariables = Exact<{
  CHATROOM_ID: Scalars['String']['input'];
  MESSAGE_ID: Scalars['Int']['input'];
}>;

export type GetMessageQuery = {
  GetMessage?: {
    items?: Array<{
      ADD_USER_ID: string;
      ADD_USER_NM: string;
      CHATROOM_ID: string;
      MESSAGE_BODY: string;
      MESSAGE_ID: number;
      ADD_DT: number;
      EDIT_FLG: string;
      FILE_FLG: string;
    } | null> | null;
  } | null;
};

export type RegisterFileMessageMutationVariables = Exact<{
  ADD_USER_ID: Scalars['String']['input'];
  ADD_USER_NM: Scalars['String']['input'];
  CHATROOM_ID: Scalars['String']['input'];
  FILE_NAME: Scalars['String']['input'];
}>;

export type RegisterFileMessageMutation = {
  RegisterFileMessage?: {
    ADD_USER_ID: string;
    ADD_USER_NM: string;
    CHATROOM_ID: string;
    MESSAGE_BODY: string;
    MESSAGE_ID: number;
    ADD_DT: number;
    EDIT_FLG: string;
    FILE_FLG: string;
  } | null;
};

export type RegisterMessageMutationVariables = Exact<{
  ADD_USER_ID: Scalars['String']['input'];
  ADD_USER_NM: Scalars['String']['input'];
  CHATROOM_ID: Scalars['String']['input'];
  MESSAGE_BODY: Scalars['String']['input'];
}>;

export type RegisterMessageMutation = {
  RegisterMessage?: {
    ADD_USER_ID: string;
    ADD_USER_NM: string;
    CHATROOM_ID: string;
    MESSAGE_BODY: string;
    MESSAGE_ID: number;
    ADD_DT: number;
    EDIT_FLG: string;
    FILE_FLG: string;
  } | null;
};

export type SearchMessageQueryVariables = Exact<{
  CHATROOM_ID: Scalars['String']['input'];
  MESSAGE_BODY: Scalars['String']['input'];
}>;

export type SearchMessageQuery = {
  SearchMessage?: {
    items?: Array<{
      ADD_USER_ID: string;
      ADD_USER_NM: string;
      CHATROOM_ID: string;
      MESSAGE_BODY: string;
      MESSAGE_ID: number;
      ADD_DT: number;
      EDIT_FLG: string;
      FILE_FLG: string;
    } | null> | null;
  } | null;
};

export type UpdateMessageMutationVariables = Exact<{
  CHATROOM_ID: Scalars['String']['input'];
  MESSAGE_BODY: Scalars['String']['input'];
  MESSAGE_ID: Scalars['Int']['input'];
}>;

export type UpdateMessageMutation = {
  UpdateMessage?: {
    ADD_USER_ID: string;
    ADD_USER_NM: string;
    CHATROOM_ID: string;
    MESSAGE_BODY: string;
    ADD_DT: number;
    EDIT_FLG: string;
    MESSAGE_ID: number;
    FILE_FLG: string;
  } | null;
};

export type GetNoticeQueryVariables = Exact<{
  USER_ID: Scalars['String']['input'];
}>;

export type GetNoticeQuery = {
  GetNotice?: {
    items?: Array<{
      CHATROOM_ID: string;
      ID: string;
      USER_ID: string;
      MESSAGE_ID: number;
      NOTICE_FLG: string;
      SEND_MAIL_FLG: string;
    } | null> | null;
  } | null;
};

export type RegisterNoticeMutationVariables = Exact<{
  CHATROOM_ID: Scalars['String']['input'];
  MESSAGE_ID: Scalars['Int']['input'];
  USER_ID: Scalars['String']['input'];
}>;

export type RegisterNoticeMutation = {
  RegisterNotice?: {
    CHATROOM_ID: string;
    ID: string;
    MESSAGE_ID: number;
    USER_ID: string;
    NOTICE_FLG: string;
    SEND_MAIL_FLG: string;
  } | null;
};

export type UpdateNoticeMutationVariables = Exact<{
  ID: Scalars['String']['input'];
}>;

export type UpdateNoticeMutation = {
  UpdateNotice?: {
    CHATROOM_ID: string;
    ID: string;
    MESSAGE_ID: number;
    USER_ID: string;
    NOTICE_FLG: string;
    SEND_MAIL_FLG: string;
  } | null;
};

export const DeleteFileDocument = gql`
  mutation DeleteFile($CHATROOM_ID: String!, $MESSAGE_ID: Int!) {
    DeleteFile(CHATROOM_ID: $CHATROOM_ID, MESSAGE_ID: $MESSAGE_ID) {
      items {
        ADD_USER_ID
        ADD_USER_NM
        CHATROOM_ID
        MESSAGE_ID
        NAME
        PATH
      }
    }
  }
`;
export const GetChatroomFileListDocument = gql`
  query GetChatroomFileList($CHATROOM_ID: String!) {
    GetChatroomFileList(CHATROOM_ID: $CHATROOM_ID) {
      items {
        ADD_USER_ID
        ADD_USER_NM
        CHATROOM_ID
        MESSAGE_ID
        PATH
        NAME
      }
    }
  }
`;
export const RegisterFileDocument = gql`
  mutation RegisterFile(
    $ADD_USER_ID: String!
    $ADD_USER_NM: String!
    $CHATROOM_ID: String!
    $MESSAGE_ID: Int!
    $NAME: String!
    $PATH: String!
  ) {
    RegisterFile(
      ADD_USER_ID: $ADD_USER_ID
      ADD_USER_NM: $ADD_USER_NM
      CHATROOM_ID: $CHATROOM_ID
      MESSAGE_ID: $MESSAGE_ID
      NAME: $NAME
      PATH: $PATH
    ) {
      items {
        ADD_USER_ID
        ADD_USER_NM
        CHATROOM_ID
        MESSAGE_ID
        NAME
        PATH
      }
    }
  }
`;
export const DeleteChatroomDocument = gql`
  mutation DeleteChatroom($CHATROOM_ID: String!) {
    DeleteChatroom(CHATROOM_ID: $CHATROOM_ID) {
      CHATROOM_ID
      KEY
      KIND
      NAME
      DELETE_FLG
    }
  }
`;
export const GetChatroomByKindDocument = gql`
  query GetChatroomByKind($KEY: String!, $SUB_KEY: String) {
    GetChatroomByKind(KEY: $KEY, SUB_KEY: $SUB_KEY) {
      items {
        CHATROOM_ID
        KEY
        SUB_KEY
        KIND
        NAME
        DELETE_FLG
      }
    }
  }
`;
export const GetChatroomDetailDocument = gql`
  query GetChatroomDetail($CHATROOM_ID: String!) {
    GetChatroomDetail(CHATROOM_ID: $CHATROOM_ID) {
      CHATROOM_ID
      KEY
      SUB_KEY
      KIND
      NAME
      DELETE_FLG
    }
  }
`;
export const RegisterChatroomDocument = gql`
  mutation RegisterChatroom($KEY: String!, $KIND: String!, $NAME: String!, $SUB_KEY: String) {
    RegisterChatroom(KEY: $KEY, KIND: $KIND, NAME: $NAME, SUB_KEY: $SUB_KEY) {
      CHATROOM_ID
      KEY
      SUB_KEY
      KIND
      NAME
      DELETE_FLG
    }
  }
`;
export const UpdateChatroomDocument = gql`
  mutation UpdateChatroom($CHATROOM_ID: String!, $NAME: String!) {
    UpdateChatroom(CHATROOM_ID: $CHATROOM_ID, NAME: $NAME) {
      CHATROOM_ID
      KEY
      KIND
      NAME
      DELETE_FLG
    }
  }
`;
export const DeleteChatroomMemberDocument = gql`
  mutation DeleteChatroomMember($CHATROOM_ID: String!, $USER_ID: String!) {
    DeleteChatroomMember(CHATROOM_ID: $CHATROOM_ID, USER_ID: $USER_ID) {
      CHATROOM_ID
      KIND
      READ_MESSAGE_ID
      USER_ID
    }
  }
`;
export const GetChatroomListDocument = gql`
  query GetChatroomList($USER_ID: String!) {
    GetChatroomList(USER_ID: $USER_ID) {
      items {
        USER_ID
        CHATROOM_ID
        KIND
        READ_MESSAGE_ID
      }
    }
  }
`;
export const GetChatroomMemberDocument = gql`
  query GetChatroomMember($CHATROOM_ID: String!) {
    GetChatroomMember(CHATROOM_ID: $CHATROOM_ID) {
      items {
        USER_ID
        CHATROOM_ID
        KIND
        READ_MESSAGE_ID
      }
    }
  }
`;
export const GetChatroomReadStatusDocument = gql`
  query GetChatroomReadStatus($CHATROOM_ID: String!, $USER_ID: String!) {
    GetChatroomReadStatus(CHATROOM_ID: $CHATROOM_ID, USER_ID: $USER_ID) {
      CHATROOM_ID
      KIND
      READ_MESSAGE_ID
      USER_ID
    }
  }
`;
export const RegisterChatroomMemberDocument = gql`
  mutation RegisterChatroomMember($CHATROOM_ID: String!, $KIND: String!, $READ_MESSAGE_ID: Int!, $USER_ID: String!) {
    RegisterChatroomMember(
      CHATROOM_ID: $CHATROOM_ID
      KIND: $KIND
      READ_MESSAGE_ID: $READ_MESSAGE_ID
      USER_ID: $USER_ID
    ) {
      CHATROOM_ID
      KIND
      READ_MESSAGE_ID
      USER_ID
    }
  }
`;
export const UpdateChatroomReadStatusDocument = gql`
  mutation UpdateChatroomReadStatus($CHATROOM_ID: String!, $READ_MESSAGE_ID: Int!, $USER_ID: String!) {
    UpdateChatroomReadStatus(CHATROOM_ID: $CHATROOM_ID, READ_MESSAGE_ID: $READ_MESSAGE_ID, USER_ID: $USER_ID) {
      CHATROOM_ID
      KIND
      READ_MESSAGE_ID
      USER_ID
    }
  }
`;
export const DeleteMessageDocument = gql`
  mutation DeleteMessage($CHATROOM_ID: String!, $MESSAGE_ID: Int!) {
    DeleteMessage(CHATROOM_ID: $CHATROOM_ID, MESSAGE_ID: $MESSAGE_ID) {
      ADD_USER_ID
      ADD_USER_NM
      CHATROOM_ID
      MESSAGE_BODY
      MESSAGE_ID
      ADD_DT
      EDIT_FLG
      FILE_FLG
    }
  }
`;
export const GetAllMessageDocument = gql`
  query GetAllMessage($CHATROOM_ID: String!) {
    GetAllMessage(CHATROOM_ID: $CHATROOM_ID) {
      items {
        ADD_USER_ID
        ADD_USER_NM
        CHATROOM_ID
        MESSAGE_BODY
        MESSAGE_ID
        ADD_DT
        EDIT_FLG
        FILE_FLG
      }
    }
  }
`;
export const GetMessageDocument = gql`
  query GetMessage($CHATROOM_ID: String!, $MESSAGE_ID: Int!) {
    GetMessage(CHATROOM_ID: $CHATROOM_ID, MESSAGE_ID: $MESSAGE_ID) {
      items {
        ADD_USER_ID
        ADD_USER_NM
        CHATROOM_ID
        MESSAGE_BODY
        MESSAGE_ID
        ADD_DT
        EDIT_FLG
        FILE_FLG
      }
    }
  }
`;
export const RegisterFileMessageDocument = gql`
  mutation RegisterFileMessage(
    $ADD_USER_ID: String!
    $ADD_USER_NM: String!
    $CHATROOM_ID: String!
    $FILE_NAME: String!
  ) {
    RegisterFileMessage(
      ADD_USER_ID: $ADD_USER_ID
      ADD_USER_NM: $ADD_USER_NM
      CHATROOM_ID: $CHATROOM_ID
      FILE_NAME: $FILE_NAME
    ) {
      ADD_USER_ID
      ADD_USER_NM
      CHATROOM_ID
      MESSAGE_BODY
      MESSAGE_ID
      ADD_DT
      EDIT_FLG
      FILE_FLG
    }
  }
`;
export const RegisterMessageDocument = gql`
  mutation RegisterMessage(
    $ADD_USER_ID: String!
    $ADD_USER_NM: String!
    $CHATROOM_ID: String!
    $MESSAGE_BODY: String!
  ) {
    RegisterMessage(
      ADD_USER_ID: $ADD_USER_ID
      ADD_USER_NM: $ADD_USER_NM
      CHATROOM_ID: $CHATROOM_ID
      MESSAGE_BODY: $MESSAGE_BODY
    ) {
      ADD_USER_ID
      ADD_USER_NM
      CHATROOM_ID
      MESSAGE_BODY
      MESSAGE_ID
      ADD_DT
      EDIT_FLG
      FILE_FLG
    }
  }
`;
export const SearchMessageDocument = gql`
  query SearchMessage($CHATROOM_ID: String!, $MESSAGE_BODY: String!) {
    SearchMessage(MESSAGE_BODY: $MESSAGE_BODY, CHATROOM_ID: $CHATROOM_ID) {
      items {
        ADD_USER_ID
        ADD_USER_NM
        CHATROOM_ID
        MESSAGE_BODY
        MESSAGE_ID
        ADD_DT
        EDIT_FLG
        FILE_FLG
      }
    }
  }
`;
export const UpdateMessageDocument = gql`
  mutation UpdateMessage($CHATROOM_ID: String!, $MESSAGE_BODY: String!, $MESSAGE_ID: Int!) {
    UpdateMessage(CHATROOM_ID: $CHATROOM_ID, MESSAGE_BODY: $MESSAGE_BODY, MESSAGE_ID: $MESSAGE_ID) {
      ADD_USER_ID
      ADD_USER_NM
      CHATROOM_ID
      MESSAGE_BODY
      ADD_DT
      EDIT_FLG
      MESSAGE_ID
      FILE_FLG
    }
  }
`;
export const GetNoticeDocument = gql`
  query GetNotice($USER_ID: String!) {
    GetNotice(USER_ID: $USER_ID) {
      items {
        CHATROOM_ID
        ID
        USER_ID
        MESSAGE_ID
        NOTICE_FLG
        SEND_MAIL_FLG
      }
    }
  }
`;
export const RegisterNoticeDocument = gql`
  mutation RegisterNotice($CHATROOM_ID: String!, $MESSAGE_ID: Int!, $USER_ID: String!) {
    RegisterNotice(CHATROOM_ID: $CHATROOM_ID, MESSAGE_ID: $MESSAGE_ID, USER_ID: $USER_ID) {
      CHATROOM_ID
      ID
      MESSAGE_ID
      USER_ID
      NOTICE_FLG
      SEND_MAIL_FLG
    }
  }
`;
export const UpdateNoticeDocument = gql`
  mutation UpdateNotice($ID: String!) {
    UpdateNotice(ID: $ID) {
      CHATROOM_ID
      ID
      MESSAGE_ID
      USER_ID
      NOTICE_FLG
      SEND_MAIL_FLG
    }
  }
`;
